import axios from "axios";
import moment from "moment-timezone";

import authHeader from "./auth-header";
import ErrorService from "./error.service";
import AdminService from "./admin.service";
import UserService from "./user.service";
import SurveyService from "./survey.service";
import ClientService from "./client.service";
import ReportService from "./report.service";

const BASE_URL = AdminService.getBaseUrl();
const API_URL = BASE_URL + "/api/v1/survey-summary";

const GET_RESPONSE_SUMMARY = "Loading respondent data.....";

class ResponseService {
  async getResponseSummary(startDate, endDate, status, callback, chatApp) {
    AdminService.displayInfoMessage({ text: GET_RESPONSE_SUMMARY }, { duration: -1 });
    let clientId = ClientService.getClientId();
    let clientCode = ClientService.getClientCode();
    if (clientId != 0) {
      const params = new URLSearchParams();
      params.append("clientCode", clientCode);
      params.append("startDate", startDate);
      params.append("endDate", endDate);
      params.append("status", status);
      params.append("surveyId", SurveyService.getSurveyId());
      params.append("userId", UserService.getUserId());
      await axios
        .post(API_URL + "/get-response-summary", params, { headers: await authHeader() })
        .then(response => callback(response))
        .catch(error => {
          error.message += ErrorService.mergeError(error.response);
          ErrorService.processError("ResponseService.getResponseSummary", error, "survey-designer", chatApp);
        });
    }
  }
  async getSurveyResponses(surveyId, surveyTakerId, callback, chatApp) {
    AdminService.displayInfoMessage({ text: GET_RESPONSE_SUMMARY }, { duration: -1 });
    let clientId = ClientService.getClientId();
    if (clientId != 0) {
      const params = new URLSearchParams();
      params.append("surveyTakerId", surveyTakerId);
      params.append("surveyId", surveyId);
      params.append("userId", UserService.getUserId());
      await axios
        .post(API_URL + "/get-survey-responses", params, { headers: await authHeader() })
        .then(response => callback(response))
        .catch(error => {
          error.message += ErrorService.mergeError(error.response);
          ErrorService.processError("ResponseService.getSurveyResponses", error, "survey-designer", chatApp);
        });
    }
  }

  getResponseSummaryTableColumnData() {
    return [
      { title: "Survey Taker Id", data: "surveySummaryId", name: "surveySummaryId", class: "text-left", width: "7rem" },
      { title: "Survey Taker Hash", data: "surveyTakerId", name: "surveyTakerId", width: "7rem" },
      { title: "First Name", data: "firstName", name: "firstName", width: "6rem" },
      { title: "Last Name", data: "lastName", name: "lastName", width: "6rem" },
      {
        title: "Status",
        data: "status",
        className: "",
        name: "status",
        width: "5rem",
        render: function(data, type, row) {
          var statusMap = {
            C: { label: "Complete", style: "warning" },
            I: { label: "Partial", style: "success" },
            O: { label: "Partial", style: "success" }
          };
          if (type === "display") {
            return "<p class='m-0 p-0' style='width: 4rem;'><span class='badge badge-" + statusMap[data].style + "'>" + statusMap[data].label + "</span></p>";
          } else {
            return data;
          }
        }
      },
      { title: "Grade", data: "grade", name: "grade", width: "5rem" },
      { title: "Points", data: "points", name: "points", class: "text-left", width: "5rem" },
      {
        title: "Date Started",
        data: "dateStarted",
        type: "date",
        name: "dateStarted",
        class: "text-left", 
        width: "7rem",
        render: function(data, type, row) {
          if (data != null) {
            return moment(data, "YYYY-MM-DDTHH:mm:ss.SSSZ").tz("America/Toronto").format("MM/DD/YYYY");
          } else {
            return "--";
          }
        }
      },
      {
        title: "Date Completed",
        data: "dateCompleted",
        type: "date",
        name: "dateCompleted",
        class: "text-left", 
        width: "8rem",
        render: function(data, type, row) {
          if (data != null) {
            return moment(data, "YYYY-MM-DDTHH:mm:ss.SSSZ").tz("America/Toronto").format("MM/DD/YYYY");
          } else {
            return "--";
          }
        }
      },
      {
        title: "",
        bVisible: true,
        data: "surveySummaryId",
        name: "id",
        width: "8rem",
        className: "select-checkbox text-center",
        render: function(data, type, full, meta) {
          //return '<input type="checkbox" name="id[]" value="' + data.surveySummaryId + '">';
          return '<button type="button" class="btn btn-primary ml-2"> View Responses </button>';
        }
      }
    ];
  }
}

export default new ResponseService();
